import { useRef } from 'react';
import Layout from '@/components/feature/Layout';
import useDocumentMeta from '@/hooks/useDocumentMeta';
import useEditorialReveal from '@/hooks/useEditorialReveal';
import SectionLabel from '@/components/feature/SectionLabel';
import ProjectGrid from '@/components/feature/ProjectGrid';
import FinalCta from '@/components/feature/FinalCta';

export default function ProjectsPage() {
  useDocumentMeta(
    'Projects | Selected Exterior Walls & Facade Finishes | MATERA',
    'Selected walls by MATERA: residential exterior restorations, render and stucco finishes and mineral coatings, browsable as a grid or list with finish and surface details.',
  );
  const intro = useRef<HTMLDivElement>(null);
  useEditorialReveal(intro);
  return (
    <Layout>
      <section className="pt-32 md:pt-40 pb-20 md:pb-28 bg-background-50">
        <div className="shell">
          <div ref={intro} className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-14 md:mb-20">
            <div className="lg:col-span-8">
              <SectionLabel index="—">Projects</SectionLabel>
              <h1 data-reveal="title" className="display mt-8 text-[clamp(2.4rem,7vw,6.5rem)]">Selected walls</h1>
            </div>
            <p className="lg:col-span-3 lg:col-start-10 self-end text-[15px] leading-relaxed text-foreground-700">
              Restoration and finish work on residential exteriors — render, stucco and mineral surfaces.
            </p>
          </div>
          <ProjectGrid />
        </div>
      </section>
      <FinalCta />
    </Layout>
  );
}